<template>
    <div class="title-bar dsp-flex layout-detail-title-bar">
        <div class="title-side title-gray detail-title-left">
            <span class="title-back" @click="goBack"><i class="iconfont icon-xiangzuo"></i>返回</span>
            <span @click="clickRecord">八字库</span>
        </div>
        <div class="title-middle" @click="clickName">
            <span v-if="hideName">匿名 {{personInfo.sex == 0 ? '男' : '女'}}</span>
            <span v-else v-bind:class="{'title-word-small': personInfo.f_name && personInfo.f_name.length > 6 && personInfo.f_name.length <= 10, 'title-word-smallest' : personInfo.f_name && personInfo.f_name.length > 10}">{{personInfo.f_name}} {{personInfo.sex == 0 ? '男' : '女'}}</span>
        </div>
        <div class="title-side title-right detail-title-right" >
            <!-- Todo:截图的icon及功能 -->
            <!-- <i class="iconfont icon-more tr-icon hide"></i> -->
            <span @click="clickMore">起盘</span>
            <span v-if="shareData && shareData.type == 4" class="title-span" @click="editSave"><span class="title-save">保存</span></span>
            <span v-else class="title-span" @click="editDetail">编辑</span>
        </div>
    </div>
</template>

<script>
import { UTILS } from '../../modules/utils'
import { DOM, RECORD_DOM } from '../../modules/dom'
import { SHARE } from '../../modules/share'
export default {
    name: 'DetailTitleBar',
    computed: {
        hideName() {
            return this.$store.state.detail.hideName
        },
        personInfo(){
            return this.$store.state.detail.personInfo
        },
        shareData() {
            return this.$store.state.share.shareData
        }
    },
    data(){
        return {
            personName: '匿名'
        }
    },
    methods:{
        goBack() {
            // 处理detail部分的返回:带了from的返回到from，不然返回到record
            var me = this,
                curPath = this.$router.history.current.path,
                params = this.$router.history.current.params.from;
            params = params ? params.replace('_', '/') : '';
            console.log('DetailTitleBar-----clickBack:::::::', params)
            // 处理分享页面的返回:跳转到起盘页
            if(curPath.indexOf('/share') != -1) {
                this.$router.replace('/collate');

                me.$store.state.share.shareId = '';
                me.$store.dispatch('detail/resetData');
                me.$store.dispatch('share/resetData');
                setTimeout(() => {
                    SHARE.initConfigShare();
                }, 100);
                return;
            }
            
            if(params != ''){
                this.$router.replace('/' + params);
            }else{
                this.$router.replace('/record');
            }

            var me = this;
            setTimeout(() => {
                me.$store.state.share.shareId = '';
                me.$store.dispatch('detail/resetData');
                me.$store.dispatch('share/resetData');
                // 四柱起盘页
                if(params && params == 'collate/advancedcollate') {
                    me.$store.dispatch('collate/initSizhuCollate');
                    DOM.hidePageByClassName('collate-page');
                }
                SHARE.initConfigShare();

                // 处理过滤列表数据:返回之前查看的数据
                if(curPath.indexOf('/record') != -1) {
                    me.$store.dispatch('record/updateRecordFilterList');
                    RECORD_DOM.resetRecordListContentStyle();
                }
            }, 100);
        },
        clickName() {
            // 点击切换名字
            this.$store.state.detail.hideName = !this.hideName;
            var me = this;
            setTimeout(() => {
                me.$store.dispatch('detail/updateQrCodeValue');
                SHARE.initConfigShare();
            }, 100);
        },
        clickRecord() {
            this.$store.state.share.shareId = '';
            this.$store.dispatch('detail/resetData');
            this.$store.dispatch('collate/resetData');
            this.$store.dispatch('group/resetChooseGroupData');
            this.$store.dispatch('share/resetData');
            var me = this;
            setTimeout(() => {
                me.$router.replace('/record');
                // 处理过滤列表数据:返回之前查看的数据
                me.$store.dispatch('record/updateRecordFilterList');
            }, 10);
        },
        clickMore() {
            this.$store.state.share.shareId = '';
            this.$store.dispatch('detail/resetData');
            this.$store.dispatch('collate/resetData');
            this.$store.dispatch('group/resetChooseGroupData');
            this.$store.dispatch('share/resetData');
            var me = this;
            setTimeout(() => {
                me.$router.replace('/collate');
            }, 10);
        },
        editDetail() {
            var me = this;
            // 初始化数据
            this.$store.dispatch('edit/initEditDetail');
            this.$store.dispatch('collate/initCollateFormData', this.$store.state.detail.personInfo);
            this.$store.dispatch('group/resetChooseGroupData');
            this.$store.dispatch('group/initGroupData');
            this.$store.dispatch('label/initLabelList', {
                cb: function() {
                    me.$store.dispatch('label/initSelectedLabelFromDetail', me.personInfo);
                }
            });
            // 页面跳转
            var path = this.$router.history.current.path;
            if(path.indexOf('share') != -1){
                this.$router.replace('/edit/record/' + this.$store.state.detail.personInfo.id);
            }else{
                path = path.replace('detail', 'edit');
                this.$router.replace(path);
            }
        },
        editSave() {
            this.$store.state.share.shareChanged = true;
            this.$store.dispatch('share/updateShareSave');
        }
    }
}
</script>